export const WEEKDAY_DD_MM_YYYY = {
    weekday: 'long',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
} satisfies Intl.DateTimeFormatOptions;